__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-01-05-1767612272-stable-dev/";